module.exports = __webpack_public_path__ + "img/lil_bar.d5c1f166.png";